import _ from 'lodash';
import WifiConnectTestTooltip from '../../tooltip/types/WifiConnectTestTooltip';

const wifiConnectTestMetric = (key, label, color) => ({
    key,
    label,
    color,
    units: 's',
    multiplier: 2,
});

const degradedMetricDef = {
    hidden: true,
    threshold: 'degraded',
    key: 'th_m6_degraded',
    label: 'Degraded Threshold',
    color: 'yellow',
    units: 's',
    multiplier: 2,
};

const excessiveMetricDef = {
    hidden: true,
    threshold: 'excessive',
    key: 'th_m6_excessive',
    label: 'Excessive Threshold',
    color: 'orange',
    units: 's',
    multiplier: 2,
};

const defaultThresholds = {
    degraded: 10,
    critical: 15,
};

export const wifiConnectTest = {
    tooltip: WifiConnectTestTooltip,
    chartType: 'areaspline',
    yAxis: [
        {
            title: {
                text: 'Seconds',
            },
        },
        {
            opposite: true,
            title: {
                text: 'Signal Quality (%)',
            },
        },
    ],
    statusMetric: 'status',
    metricMapping: (num) => (_.isNumber(num) ? num : undefined),
    stacking: 'normal',
    chartTrends: [
        {
            hidden: true,
            key: 'avgtotal_connection_time',
            label: 'Connect',
            color: '#2b908f',
            units: 's',
            multiplier: 2,
        },
        wifiConnectTestMetric('avgassociate', 'Associate', '#67db74'),
        wifiConnectTestMetric('avgauthenticate', 'Authenticate', '#2B908F'),
        wifiConnectTestMetric('avgdhcp', 'DHCP', '#8085E9'),
        {
            hidden: true,
            key: 'avgconnection_attempts',
            label: 'Attempts',
            color: '#434348',
            units: '',
            multiplier: 0,
        },
        {
            hidden: false,
            key: 'avgwifi_signal_level_pct',
            label: 'Signal Quality',
            color: '#E9E480',
            units: '%',
            multiplier: 0,
            chartType: 'spline',
            index: 1,
        },
        degradedMetricDef,
        excessiveMetricDef,
    ],
    testThresholds: {
        degraded: {
            def: degradedMetricDef,
            value: defaultThresholds.degraded,
        },
        excessive: {
            def: excessiveMetricDef,
            value: defaultThresholds.critical,
        },
    },
};
export function getWifiConnectTestChartDef(test) {
    // extract thresholds for test or testtype
    const thresholds = test?.thresholds || test?.testType?.thresholds || defaultThresholds;

    return {
        ...wifiConnectTest,
        testThresholds: {
            degraded: {
                def: degradedMetricDef,
                value: thresholds?.degraded,
            },
            excessive: {
                def: excessiveMetricDef,
                value: thresholds?.critical,
            },
        },
    };
}
